import Vue from "vue";
import VueRouter from "vue-router";

import Meta from "vue-meta";
import auth from "@/router/auth";

Vue.use(VueRouter);

Vue.use(Meta, {
  keyName: "metaInfo", // the component option name that vue-meta looks for meta info on.
  attribute: "data-vue-meta", // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: "data-vue-meta-server-rendered", // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: "vmid", // the property name that vue-meta uses to determine whether to overwrite or append a tag
});

const routes = [
  // {
  //   path: "/",
  //   name: "home-index",
  //   component: Home,
  //   beforeEnter: auth.requireAuth,
  // },
  {
    path: "/login",
    name: "account-login",
    component: () => import("@/views/account/Login.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  // pack
  {
    path: "/home",
    name: "goods-home",
    component: () => import("@/views/goods/Home.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/customs",
    name: "customs-home",
    component: () => import("@/views/customs/Home.vue"),
    beforeEnter: auth.requireAnyPermission([
      "awaiting-confirmation.view-all",
      "awaiting-confirmation.view-all-agency",
      "quote-clean-baogia.index",
      "quote-file-baogia.index",
      "quote-file-baogia.view-wh-release-note",
      "import-warehouse.index-all",
      "import-warehouse.index-company",
      "import-warehouse.index-agency",
      "cleared_custom.index",
    ]),
  },
  {
    path: "/customs/goods-awaiting-confirmation",
    name: "goods-awaiting-confirmation",
    component: () => import("@/views/customs/GoodsAwaitingConfirmation.vue"),
    beforeEnter: auth.requireAnyPermission([
      "awaiting-confirmation.view-all",
      "awaiting-confirmation.view-all-agency",
    ]),
  },
  {
    path: "/customs/goods-awaiting-clearance",
    name: "customs-clearance-menu",
    component: () => import("@/views/customs/ClearanceMenu.vue"),
    beforeEnter: auth.requireAnyPermission([
      "quote-clean-baogia.index",
      "quote-file-baogia.index",
      "quote-file-baogia.view-wh-release-note",
      "import-warehouse.index-all",
      "import-warehouse.index-company",
      "import-warehouse.index-agency",
    ]),
  },
  {
    path: "/tax/list",
    name: "tax-list",
    component: () => import("@/views/tax/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/list-of-good",
    name: "tax-list-of-good",
    component: () => import("@/views/tax/ListOfGood.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/brand-protect",
    name: "tax-brand-protect",
    component: () => import("@/views/tax/BrandProtect.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/brand-protect/:id",
    name: "tax-brand-protect-detail",
    component: () => import("@/views/tax/BrandProtectDetail.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/schedule",
    name: "tax-schedule",
    component: () => import("@/views/tax/Schedule.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/option/:type",
    name: "tax-option",
    component: () => import("@/views/tax/Option.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/warning-price",
    name: "tax-warning-price",
    component: () => import("@/views/tax/WarningPrice.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/warning-price/history",
    name: "tax-warning-price-history",
    component: () => import("@/views/tax/WarningPriceHistory.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/unit-conversion",
    name: "tax-unit-conversion",
    component: () => import("@/views/tax/UnitConversion.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/policy",
    name: "tax-policy",
    component: () => import("@/views/tax/Policy.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/product-risk",
    name: "tax-product-risk",
    component: () => import("@/views/tax/ProductRisk.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/evaluation-method",
    name: "tax-evaluation-method",
    component: () => import("@/views/tax/EvaluationMethod.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/evaluation-method/create",
    name: "tax-evaluation-method-create",
    component: () => import("@/views/tax/EvaluationMethodCreate.vue"),
    beforeEnter: auth.requireAuth,
  },
  // báo giá
  {
    path: "/quotes",
    name: "quotes",
    component: () => import("@/views/quote/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quotes-update/:quote_id",
    name: "quotes-update",
    component: () => import("@/views/quote/Update.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quotes-edit-history/:quote_id",
    name: "quotes-edit-history",
    component: () => import("@/views/quote/EditHistory.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quotes-comment/:quote_id",
    name: "quotes-comment",
    component: () => import("@/views/quote/Comment.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/waiting-for-quote",
    name: "waiting-for-quote",
    component: () => import("@/views/waiting-for-quote/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/waiting-for-xnk-approval",
    name: "waiting-for-xnk-approval",
    component: () => import("@/views/waiting-for-xnk-approval/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/manager-approval-quote",
    name: "manager-approval-quote",
    component: () => import("@/views/manager-approval-quote/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/history-import",
    name: "tax/history-import",
    component: () => import("@/views/tax/HistoryImport.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/goods-awaiting-clearance",
    name: "tax/goods-awaiting-clearance",
    component: () => import("@/views/tax/GoodsAwaitingClearance.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/goods-cleared-custom",
    name: "tax/goods-cleared-custom",
    component: () => import("@/views/tax/GoodsClearedCustom.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/tax/list-file-xnk",
    name: "tax/list-file-xnk",
    component: () => import("@/views/tax/ListFileXNK.vue"),
    beforeEnter: auth.requireAnyPermission(["quote-file-baogia.index"]),
  },
  {
    path: "/tax/warehouse-release-note",
    name: "tax/warehouse-release-note",
    component: () => import("@/views/tax/WarehouseReleaseNote.vue"),
    beforeEnter: auth.requireAnyPermission(["quote-file-baogia.view-wh-release-note"]),
  },
  {
    path: "/tax/import-warehouse",
    name: "tax/import-warehouse",
    component: () => import("@/views/tax/ImportWarehouse.vue"),
    beforeEnter: auth.requireAnyPermission([
      "import-warehouse.index-all",
      "import-warehouse.index-company",
      "import-warehouse.index-agency",
    ]),
  },
  {
    path: "/setting/list",
    name: "setting-list",
    component: () => import("@/views/setting/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/user",
    name: "setting-user",
    component: () => import("@/views/user/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/list-user-vpo",
    name: "setting-lists-user-vpo",
    component: () => import("@/views/user/Vpo.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/user/create",
    name: "setting-user-create",
    component: () => import("@/views/user/Create.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/user/edit/:id",
    name: "setting-user-edit",
    component: () => import("@/views/user/Edit.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/company",
    name: "setting-company",
    component: () => import("@/views/company/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/company-import-hs-codes",
    name: "setting-company-import-hs-codes",
    component: () => import("@/views/company-import-hs-code/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/acceptance-rate",
    name: "setting-acceptance-rate",
    component: () => import("@/views/acceptance-rate/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/assign-quote-staff",
    name: "setting-assign-quote-staff",
    component: () => import("@/views/assign-quote-staff/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/service-price-list",
    name: "setting-service-price-list",
    component: () => import("@/views/service-price/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/company/create",
    name: "setting-company-create",
    component: () => import("@/views/company/Create.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/company/edit/:id",
    name: "setting-company-edit",
    component: () => import("@/views/company/Edit.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/role",
    name: "setting-role",
    component: () => import("@/views/role/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/border-gate",
    name: "setting-border-gate",
    component: () => import("@/views/setting/BorderGate.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/change-password",
    name: "setting-change-password",
    component: () => import("@/views/setting/ChangePassword.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quote/history",
    name: "quote-history",
    component: () => import("@/views/quote/History.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/home/accountant",
    name: "home-accountant",
    component: () => import("@/views/accountant/home.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/pending",
    name: "pending",
    component: () => import("@/views/accountant/pending/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/declaration",
    name: "declaration",
    component: () => import("@/views/accountant/declaration/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/accounting/transport-partners",
    name: "accountant-transport-partners",
    component: () => import("@/views/accountant/transport-partners/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/accounting/expense-items",
    name: "accountant-expense-items",
    component: () => import("@/views/accountant/expense-items/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/accounting/shipments",
    name: "accountant-shipments",
    component: () => import("@/views/accountant/shipments/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/accounting/cash-balance",
    name: "accountant-cash-balance",
    component: () => import("@/views/accountant/cash-balance/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/accounting/income-expenditure",
    name: "accountant-income-expenditure",
    component: () => import("@/views/accountant/income-expenditure/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/accounting/partner-debt",
    name: "accountant-partner-debt",
    component: () => import("@/views/accountant/partner-debt/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/notification",
    name: "notification",
    component: () => import("@/views/notification/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/customers",
    name: "setting-customer",
    component: () => import("@/views/customer/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/customer/create",
    name: "setting-customer-create",
    component: () => import("@/views/customer/Create.vue"),
    beforeEnter: auth.requireAuth,
  },
  // {
  //   path: "/setting/customer/edit/:id",
  //   name: "setting-customer-edit",
  //   component: () => import("@/views/customer/Edit.vue"),
  //   beforeEnter: auth.requireAuth,
  // },
  {
    path: "/setting/company-xnk",
    name: "setting-company-xnk",
    component: () => import("@/views/company-xnk/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quote/report",
    name: "report-list",
    component: () => import("@/views/report/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quote/report/approval-performance",
    name: "report-approval-performance",
    component: () => import("@/views/report/ApprovalPerformance.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quote/report/revenue",
    name: "report-revenue",
    component: () => import("@/views/report/Revenue.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quote/report/import-goods",
    name: "report-import-goods",
    component: () => import("@/views/report/ImportGoods.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quote/report/approval-management",
    name: "report-approval-management",
    component: () => import("@/views/report/ApprovalManagement.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/chat-list",
    name: "chat-list",
    component: () => import("@/views/chat/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
